// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-loading-spinner{display:flex;justify-content:center;margin-top:100px;width:100%}.search-no-results{padding-top:100px;text-align:center;color:#757575;font-size:31px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
